import ko from "knockout";
import _ from "lodash";
import ViewModel from "viewModels/ViewModel";
import PlaybackHeaderView from "viewModels/PlaybackHeaderView";

export default ViewModel.extend(function (
    chatTranscript,
    conversationObservable,
    recordingObservable
) {
    const self = this;
    const chat = ko.observable(chatTranscript);
    self.chatMessages = ko.observableArray();
    self.isLoading = ko.observable(false);
    self.conversation = conversationObservable;
    self.recording = recordingObservable;
    self.chatHeader = self.subView(
        PlaybackHeaderView,
        ko.i18n.renderString("playback.recording.duration"),
        "chat"
    );

    if (chat()) {
        // Get all chats with standard body type (or no body type, for v1 compatability)
        const standardBodyChats = _.filter(chat(), function (chatMessage) {
            chatMessage.isStandard =
                !chatMessage.bodyType || chatMessage.bodyType === "STANDARD";
            chatMessage.isNotice = chatMessage.bodyType === "NOTICE";
            return chatMessage.isStandard || chatMessage.isNotice;
        });

        self.chatMessages(
            _.map(standardBodyChats, function (chatMessage) {
                const defaultMessage = {
                    userInfo: ko.observable({
                        id: ko.observable(
                            chatMessage.user ? chatMessage.user.id : ""
                        ),
                    }),
                };

                const decoratedMessage = ko.observable(
                    _.assign(defaultMessage, chatMessage)
                );

                return decoratedMessage;
            })
        );

        if (self.chatMessages().length > 0) {
            // get startTime and endTime and calculate the duration
            if (
                self.conversation &&
                self.conversation().startTime &&
                self.conversation().endTime
            ) {
                self.chatHeader.setHeader(
                    self.conversation().startTime(),
                    self.conversation().endTime()
                );
            } else if (
                self.recording &&
                self.recording().startTime &&
                self.recording().endTime
            ) {
                self.chatHeader.setHeader(
                    self.recording().startTime,
                    self.recording().endTime
                );
            }
        }
    }
});
